import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getHeaders } from "./getHeaders";

export const getCart = createAsyncThunk(
  "Cart/getCart",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/cart/${id}`, {
          headers: getHeaders(),
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const addToCart = createAsyncThunk(
  "Cart/addToCart",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/admin/cart`, data, {
          headers: getHeaders(true),
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const updateCart = createAsyncThunk(
  "Cart/updateCart",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/cart/${data.id}/update`,
          {
            quantity: data?.quantity,
          },
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const DeleteFromCart = createAsyncThunk(
  "Cart/DeleteFromCart",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/cart/${id}`,
        {
          headers: getHeaders(),
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const CheckoutCart = createAsyncThunk(
  "Cart/CheckoutCart",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/cart/checkout/${id}`,
          {},
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const CartLocation = createAsyncThunk(
  "Cart/CartLocation",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/cart/location/${data.id}`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
const CartSlice = createSlice({
  name: "Cart",
  initialState: {
    isCartLoading: false,
    error: null,
    CartData: null,
  },

  extraReducers: (builder) => {
    builder

      .addCase(getCart.pending, (state) => {
        state.isCartLoading = true;
      })
      .addCase(getCart.fulfilled, (state, action) => {
        state.isCartLoading = false;
        state.CartData = action.payload.data;
      })
      .addCase(getCart.rejected, (state, action) => {
        state.isCartLoading = false;
      })

      // addToCart
      .addCase(addToCart.pending, (state) => {
        state.isCartLoading = true;
      })
      .addCase(addToCart.fulfilled, (state, action) => {
        state.isCartLoading = false;
      })
      .addCase(addToCart.rejected, (state, action) => {
        state.isCartLoading = false;
      })
      // updateCart
      .addCase(updateCart.pending, (state) => {
        state.isCartLoading = true;
      })
      .addCase(updateCart.fulfilled, (state, action) => {
        state.isCartLoading = false;
      })
      .addCase(updateCart.rejected, (state, action) => {
        state.isCartLoading = false;
      })
      .addCase(DeleteFromCart.pending, (state) => {
        state.isCartLoading = true;
      })
      .addCase(DeleteFromCart.fulfilled, (state, action) => {
        state.isCartLoading = false;
      })
      .addCase(DeleteFromCart.rejected, (state, action) => {
        state.isCartLoading = false;
      })

      // CartLocation

      .addCase(CartLocation.pending, (state) => {
        state.isCartLoading = true;
      })
      .addCase(CartLocation.fulfilled, (state, action) => {
        state.isCartLoading = false;
      })
      .addCase(CartLocation.rejected, (state, action) => {
        state.isCartLoading = false;
      })

      .addCase(CheckoutCart.pending, (state) => {
        state.isCartLoading = true;
      })
      .addCase(CheckoutCart.fulfilled, (state, action) => {
        state.isCartLoading = false;
      })
      .addCase(CheckoutCart.rejected, (state, action) => {
        state.isCartLoading = false;
      });
  },
});

export default CartSlice.reducer;
